export const defaultGetOptionLabel = <T>(option: T) =>
  typeof option === 'string' ? option : ((option as any).name as string);

export const defaultIsOptionEqualToValue = <T>(option: T, value: T) =>
  (option as any).id === (value as any).id;
